export function Onboarding(){
  return (
    <>
      <h3>Enable Epic/Outlook Integration</h3>
      <video src="/images/EnableOutlookIntegrationTut.mp4" autoPlay muted controls loop></video>
    </>
  );
}